import { cx } from '@linaria/core';
import { useRef, useEffect } from 'react';
import { FlipIcon } from '@ui/kit';
import { PostloadedImage } from '@utils/react';
import { AudioButton } from '../../atoms/audio-button.js';
import { cardSelectors, flipTransitionDurationMs } from './_card.style.js';
import { wrapper, modifiers, image, contentWrapper, textWrapper, title, text, flipButton } from './atom.card-side-style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useHTMLContent } from '../../ast/util.print-html.js';

function CardSide(props) {
  const ref = useRef(null);
  const text$1 = useHTMLContent(props.content.text);
  const scrollTimeoutId = useRef();

  // Once a card has been deactivated, then ensure that it is scrolled to the
  // top, such that it will be as expected the next time it is flipped.
  useEffect(() => {
    window.clearTimeout(scrollTimeoutId.current);
    if (props.isVisible) {
      return;
    }
    scrollTimeoutId.current = window.setTimeout(() => {
      const scrollParent = ref.current?.closest(cardSelectors.cardSideWrapper());
      if (!scrollParent) {
        return;
      }
      scrollParent.scrollTop = 0;
    }, flipTransitionDurationMs);
  }, [props.isVisible]);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: cx(wrapper, !!props.content.image && modifiers.hasImage.className, !!props.content.audio && modifiers.hasAudio.className),
    "data-disable-polly": props.isVisible ? undefined : true,
    children: [props.content.image && /*#__PURE__*/jsx(PostloadedImage, {
      ref: props.isActive ? props.tooltipTargetRef : undefined,
      className: cx(image, props.content.scaleImage && "scalable"),
      src: props.content.image.value,
      alt: ""
    }), /*#__PURE__*/jsxs("div", {
      className: contentWrapper,
      children: [!!props.content.audio && /*#__PURE__*/jsx(AudioButton, {
        src: props.content.audio.value,
        canPlay: props.isActive,
        onAudioClicked: props.onAudioButtonClicked,
        tabIndex: props.cardHasFocus && props.isActive ? undefined : -1
      }), /*#__PURE__*/jsxs("div", {
        className: cx(textWrapper, props.content.centerText && "centered"),
        children: [/*#__PURE__*/jsx("h2", {
          className: title,
          children: props.content.label || props.fallbackLabel
        }), /*#__PURE__*/jsx("div", {
          className: text,
          children: text$1
        }), /*#__PURE__*/jsxs("button", {
          className: flipButton,
          tabIndex: props.cardHasFocus && props.isActive ? undefined : -1,
          onClick: props.onFlipButtonClicked,
          onKeyDown: evt => evt.stopPropagation(),
          children: [/*#__PURE__*/jsx(FlipIcon, {}), /*#__PURE__*/jsx("span", {
            children: "Vend kortet"
          })]
        })]
      })]
    })]
  });
}

export { CardSide };
//# sourceMappingURL=atom.card-side.js.map
